// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1LzG2","header":"MessagesList_header__koMS0","chat":"MessagesList_chat__1sFWP"};